import { motion } from "framer-motion";
import { useSite } from "@/hooks/useSite";
import { trackEvent } from "@/lib/analytics";

export default function FloatingWhatsApp() {
  const site = useSite();
  const raw = (site?.whatsapp || "").replace(/[^\d]/g, "");
  if (!raw) return null;
  const href = `https://wa.me/${raw}?text=${encodeURIComponent("Hola, me interesa recibir información sobre los servicios de KB Consultoría.")}`;
  return (
    <motion.a
      initial={{ opacity: 0, scale: 0.4 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.6, duration: 0.6, ease: [0.76, 0, 0.24, 1] }}
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp"
      aria-label="Contactar por WhatsApp"
      onClick={() => trackEvent("whatsapp_click", { source: "floating_button" })}
      className="fixed z-40 bottom-6 right-6 h-14 w-14 rounded-full bg-[#1B3B2B] text-[#F9F6F0] flex items-center justify-center shadow-[0_10px_30px_rgba(27,59,43,0.35)] hover:bg-[#2A5239] transition-colors"
    >
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6" aria-hidden="true">
        <path d="M20.52 3.48A11.86 11.86 0 0 0 12.05 0C5.49 0 .16 5.33.16 11.9c0 2.1.55 4.14 1.6 5.94L0 24l6.34-1.66a11.9 11.9 0 0 0 5.7 1.45h.01c6.56 0 11.9-5.33 11.9-11.9 0-3.18-1.24-6.17-3.43-8.41zM12.05 21.5h-.01a9.6 9.6 0 0 1-4.89-1.34l-.35-.21-3.76.98 1-3.67-.23-.38a9.55 9.55 0 0 1-1.47-5.07c0-5.28 4.3-9.58 9.6-9.58 2.56 0 4.97 1 6.78 2.82a9.5 9.5 0 0 1 2.81 6.79c0 5.29-4.3 9.66-9.48 9.66zm5.42-7.19c-.29-.14-1.75-.86-2.02-.96-.27-.1-.47-.14-.66.14-.19.29-.75.96-.92 1.16-.17.19-.34.22-.63.07-.29-.14-1.23-.45-2.34-1.45-.86-.77-1.44-1.72-1.62-2.01-.17-.29-.02-.44.12-.58.13-.13.29-.34.44-.51.15-.17.19-.29.29-.48.1-.19.05-.36-.02-.51-.07-.14-.66-1.6-.91-2.19-.24-.57-.48-.5-.66-.51h-.57c-.19 0-.51.07-.78.36-.27.29-1.02 1-1.02 2.44 0 1.44 1.04 2.83 1.19 3.02.15.19 2.06 3.14 4.99 4.4.7.3 1.25.48 1.67.62.7.22 1.34.19 1.84.12.56-.08 1.75-.72 2-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.56-.34z" />
      </svg>
    </motion.a>
  );
}
